const isMobile = () => {
  try {
    if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
      return navigator.userAgentData.mobile
    }
    if (window.matchMedia && typeof window.matchMedia === 'function') {
      const coarse = window.matchMedia('(pointer: coarse)')
      if (coarse && typeof coarse.matches === 'boolean') return coarse.matches
    }
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  } catch (e) {
    return false
  }
}

export default isMobile
